import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider } from "@/context/AppContext";
import { RequireRole, HomeRedirect, RequireTempPassword } from "@/components/Guards";
import ChangePassword from "@/pages/portal/ChangePassword";
import Apply from "@/pages/Apply";
import ApplyForm from "@/pages/portal/ApplyForm";
import Applications from "@/pages/admin/Applications";
import ApplicationDetail from "@/pages/admin/ApplicationDetail";
import { SiteFooter } from "@/components/SiteFooter";
import AdminLayout from "@/components/AdminLayout";
import PortalLayout from "@/components/PortalLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/admin/Dashboard";
import Loans from "@/pages/admin/Loans";
import NewLoan from "@/pages/admin/NewLoan";
import LoanDetail from "@/pages/admin/LoanDetail";
import Borrowers from "@/pages/admin/Borrowers";
import Settings from "@/pages/admin/Settings";
import Reports from "@/pages/admin/Reports";
import Team from "@/pages/admin/Team";
import PortalHome from "@/pages/portal/PortalHome";
import PortalLoan from "@/pages/portal/PortalLoan";
import PayPage from "@/pages/portal/PayPage";
import { PayLinkPage, PayLinkResult } from "@/pages/PayLink";
import { PayoffLinkPage, PayoffLinkResult } from "@/pages/PayoffLink";
import PaymentResult from "@/pages/portal/PaymentResult";

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomeRedirect />} />
          <Route path="/login" element={<Login />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/pay/:token" element={<PayLinkPage />} />
          <Route path="/pay/:token/result" element={<PayLinkResult />} />
          <Route path="/payoff/:token" element={<PayoffLinkPage />} />
          <Route path="/payoff/:token/result" element={<PayoffLinkResult />} />
          <Route path="/change-password" element={<RequireTempPassword><ChangePassword forced /></RequireTempPassword>} />
          <Route path="/admin" element={<RequireRole role="admin"><AdminLayout /></RequireRole>}>
            <Route index element={<Dashboard />} />
            <Route path="loans" element={<Loans />} />
            <Route path="loans/new" element={<NewLoan />} />
            <Route path="loans/:id" element={<LoanDetail />} />
            <Route path="applications" element={<Applications />} />
            <Route path="applications/:id" element={<ApplicationDetail />} />
            <Route path="borrowers" element={<Borrowers />} />
            <Route path="settings" element={<Settings />} />
            <Route path="reports" element={<Reports />} />
            <Route path="team" element={<RequireRole role="super_admin"><Team /></RequireRole>} />
          </Route>
          <Route path="/portal" element={<RequireRole role="borrower"><PortalLayout /></RequireRole>}>
            <Route index element={<PortalHome />} />
            <Route path="loans/:id" element={<PortalLoan />} />
            <Route path="loans/:id/pay" element={<PayPage />} />
            <Route path="payment/result" element={<PaymentResult />} />
            <Route path="password" element={<ChangePassword />} />
            <Route path="apply" element={<ApplyForm />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <SiteFooter />
      </BrowserRouter>
      <Toaster position="top-right" richColors={false} />
    </AppProvider>
  );
}

export default App;
